<div
  class="flex flex-column justify-center align-center h-100 text-center family-info"
>
  <div class="modal-icon">
    <img src="../../../../assets/images/svgs/alert.svg" alt="ICON" />
  </div>
  <h1 class="para-title">Transparency Disclaimer</h1>
  <p class="para-body">
    We neither receive money directly from donors nor give funds directly to
    families. We only provide a connection between both parties in a transparent
    way.
  </p>

  <button class="ui button primary basic mt-4" (click)="hideTerms()">
    Continue
  </button>
</div>

<div
  class="identifyOrAnonymous flex flex-column align-center"
  *ngIf="!termsVisible"
>
  <div
    class="flex flex-column align-center"
    *ngIf="stayAnonymous == '2'; else identify"
  >
    <!-- <div class="modal-icon mb-4">
      <img src="../../assets/images/svgs/question.svg" alt="" />
    </div> -->
    <p class="para-title text-center mt-4 mb-4">
      This information will help us when sending our gratitude notification
    </p>
  </div>

  <ng-template #identify>
    <p class="para-title text-center mt-4 mb-4">
      This information will help us when sending our gratitude notification. We
      guarantee data anonymity
    </p>
  </ng-template>

  <form [formGroup]="iAForm" (ngSubmit)="submit(iAForm)" class="w-100">
    <div class="ui form">
      <div class="field">
        <label>Name</label>
        <input formControlName="name" type="text" placeholder="Fullname" />
        <div *ngIf="name.touched && name.invalid" class="ng-invalid ng-touched">
          <small style="color: #f10b0b9d;" *ngIf="nameIsRequired()">
            Your name is required!</small
          >
        </div>
      </div>
      <div class="field">
        <label>Email</label>
        <input
          formControlName="email"
          name="email"
          type="email"
          placeholder="example@example.com"
        />
        <small> </small>
        <div
          *ngIf="email.touched && email.invalid"
          class="ng-invalid ng-touched"
        >
          <small style="color: #f10b0b9d;" *ngIf="emailIsRequired()">
            Your email address is required!</small
          >
        </div>
      </div>

      <div class="field">
        <label>Phone Number</label>
        <input
          formControlName="phone"
          name="tel2"
          type="tel"
          pattern="[0-9]{11}"
          placeholder="Enter your Phone number"
        />
        <small> </small>
        <div
          *ngIf="phone.touched && phone.invalid"
          class="ng-invalid ng-touched"
        >
          <small style="color: #f10b0b9d;" *ngIf="phoneIsRequired()">
            Your phone number is required!</small
          >
        </div>
      </div>

      <!-- <div class="field">
        <select formControlName="gender">
          <option value="">Gender</option>
          <option value="1">Male</option>
          <option value="2">Female</option>
        </select>
      </div> -->

      <!-- <div class="field">
        <div class="ui checkbox">
          <input  type="checkbox" tabindex="0" />
          <label>I agree to the Terms and Conditions</label>
        </div>
      </div> -->
    </div>

    <div class="text-center mt-4">
      <button
        [disabled]="!iAForm.valid"
        type="submit"
        class="ui primary button fluid"
      >
        Start <i hidden class="fas fa-circle-notch fa-spin"></i>
      </button>
    </div>
  </form>

  <small class="smallNotification" *ngIf="notification?.show">
    {{ notification?.message }}
  </small>
</div>
